import { render, staticRenderFns } from "./NewestPost.vue?vue&type=template&id=132642d4&scoped=true&"
import script from "./NewestPost.vue?vue&type=script&lang=js&"
export * from "./NewestPost.vue?vue&type=script&lang=js&"
import style0 from "./NewestPost.vue?vue&type=style&index=0&id=132642d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132642d4",
  null
  
)

export default component.exports